<template>
  <div>
    <div id="drive-public">
      <b-card
          class="h-full"
          header-bg-variant="primary" no-body>
          <template #header>
            <h4 class="mb-0 text-white">{{ title }}</h4>
          </template>

          <!--área de conteúdo do drive public-->
          <div class="drive-public-content p-2">
            <!-- Loading overlay -->
            <div v-if="loading" class="text-center p-4">
              <b-spinner variant="primary" label="Loading..."></b-spinner>
            </div>

            <!-- Error message -->
            <b-alert
              v-if="error"
              show
              variant="danger"
              class="mb-0"
            >
              {{ error }}
            </b-alert>

            <!-- File explorer component -->
            <template v-if="!loading && !error">
              <file-explorer-component
                :drive-public-service="drivePublicService"
                @file-open="handleFileOpen"
                @download-file="handleDownloadFile"
                @show-item-details="handleShowItemDetails"
              />
            </template>
          </div>

          <!-- Footer Area Drive Public-->
          <template #footer>
            <page-footer :showLoginLink="false"></page-footer>
          </template>
      </b-card>
    </div>

    <!-- Usando o componente reutilizável para detalhes do arquivo -->
    <file-details-popup
      v-model="showItemDetails"
      :item="selectedItem"
    />
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BLink,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BCardImg,
  BImg,
  BInputGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BAlert,
  VBTooltip,
  BModal,
  BSpinner,
} from 'bootstrap-vue'

import DriveService from '@/services/api/DriveService'
import PageFooter from '@/components/PageFooter.vue'
import FileExplorerComponent from '@/components/FileExplorer/FileExplorerComponent.vue'
import FeatherIcon from '@/components/FeatherIcon.vue'
import PublicAccessService from '@/services/api/DrivePublicService'
import FileDetailsPopup from '@/components/FileExplorer/FileDetailsPopup.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    BLink,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BCardImg,
    BImg,
    BButton,
    BAlert,
    BSpinner,
    VBTooltip,
    BModal,
    PageFooter,
    FileExplorerComponent,
    FeatherIcon,
    FileDetailsPopup,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    param_encrypted: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      service: DriveService.build(this.$vs),
      loading: false,
      error: null,
      title: 'SECURAMDATA - Drive Compartilhado',
      drivePublicService: null,
      // Detalhes do item
      showItemDetails: false,
      selectedItem: null,
    }
  },
  created() {
    // Inicializar o serviço com os parâmetros necessários
    this.drivePublicService = new PublicAccessService(
      this.service,
      this.type,
      this.param_encrypted
    );
  },
  watch: {
    type: 'handleParamsChange',
    param_encrypted: 'handleParamsChange',
  },
  methods: {
    handleShowItemDetails(item) {
      this.selectedItem = item;
      this.showItemDetails = true;
    },
    handleParamsChange() {
      console.log('handleParamsChange...');
    },

    handleDownloadFile(file) {
      this.downloadFile(file);
    },

    handleFileOpen(file) {
      if (file.type === 'file') {
        // Se o arquivo tiver url_tmp, use-a para download
        if (file.url_tmp) {
          this.downloadFile(file);
        } else {
          this.notifyError(this.$vs, 'URL temporária do recurso não encontrada para arquivo.');
          // Fallback para o método antigo, caso a url_tmp não esteja disponível
          //window.open(this.fileExplorerService.getFileDownloadUrl(file.path), '_blank');
        }
      }
    },
    /**
     * Manipula o download de um arquivo usando a url_tmp
     * @param {Object} file Objeto do arquivo a ser baixado
     */
     downloadFile(file) {
      if (!file || !file.url_tmp) {
        this.notifyError(this.$vs, 'URL temporária não disponível para download.');
        return;
      }

      try {
        const normalizedName = this.ensureFileExtension(
          file.name || 'download',
          file.extension,
          file.mime_type
        )
        this.$utils.browser.forceDownload(
          file.url_tmp,
          normalizedName,
          file.mime_type || 'application/octet-stream'
        );
        this.notifySuccess(this.$vs, 'O download do arquivo foi iniciado...');
      } catch (error) {
        console.error('Erro ao iniciar download:', error);
        this.notifyError(this.$vs, 'Não foi possível iniciar o download do arquivo');
      }
    },
    ensureFileExtension(fileName, extension, mimeType) {
      if (!fileName) return 'download'
      const normalizedExtension = extension ? extension.toLowerCase() : ''
      if (normalizedExtension && fileName.toLowerCase().endsWith(`.${normalizedExtension}`)) {
        return fileName
      }

      if (normalizedExtension) {
        return `${fileName}.${normalizedExtension}`
      }

      const mimeMap = {
        'application/zip': 'zip',
        'application/x-zip-compressed': 'zip',
        'application/x-rar-compressed': 'rar',
        'application/vnd.rar': 'rar',
        'application/x-7z-compressed': '7z'
      }

      const mapped = mimeType ? mimeMap[mimeType] : null
      return mapped ? `${fileName}.${mapped}` : fileName
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/simple-content.scss';

.bkg_img {
  position: fixed;
  scale: 1.2;
  right: 0;
  bottom: 0;
}

#drive-public {
  @apply top-0 bottom-0 right-0 left-0;
  padding: 1% 1%;
  padding-top: 3rem !important;
  @screen sm {
    padding: 1% 5%;
  };
  @screen lg {
    padding: 3% 18%;
  }

  & > .card {
    min-height: 50vh !important;

    & ._row {
      width: 100%;
    }

    & > .card-header {
      padding: 0.5rem 1.5rem;
    }
  }

  & table.b-table {
    & th, td {
      padding: 1px;
      @screen sm {
        padding: 0.72rem 2rem;
      }
    }
  }

  & .card-footer {
    padding: 0.5rem;
    @screen sm {
      padding: 1.5rem;
    }
  }
}

.drive-public-content {
  min-height: 300px;
}
</style>
